/**
 * Message Zod schemas
 */

import { z } from 'zod'
import { MESSAGE_TYPES, MESSAGE_DIRECTIONS, SENTIMENTS, REPLY_CLASSIFICATIONS } from '../constants/statuses'

export const createMessageSchema = z.object({
  leadId: z.string().min(1),
  campaignId: z.string().optional(),
  conversationId: z.string().optional(),
  direction: z.enum(MESSAGE_DIRECTIONS as unknown as [string, ...string[]]),
  type: z.enum(MESSAGE_TYPES as unknown as [string, ...string[]]),
  content: z.string().min(1).max(5000),
  strategy: z.string().max(100).optional(),
  aiGenerated: z.boolean().default(false),
})

export const classifyReplySchema = z.object({
  messageId: z.string().min(1),
  sentiment: z.enum(SENTIMENTS as unknown as [string, ...string[]]),
  classification: z.enum(REPLY_CLASSIFICATIONS as unknown as [string, ...string[]]),
})

export type CreateMessageInput = z.infer<typeof createMessageSchema>
export type ClassifyReplyInput = z.infer<typeof classifyReplySchema>
